import React from "react";
import { shape, string } from "prop-types";
import FieldLabel from "pages/_components/fields/FieldLabel";
import * as i18nUtils from "util/i18n";
import FormattedAmount from "pages/_components/FormattedAmount";

export const TEXT_TYPE = "text_type";
export const AMOUNT_TYPE = "amount_type";

const ReadText = ({ value, idField, lang, idActivity, mode, type = TEXT_TYPE, amount }) => {
    const labelText = mode === "preview" ? "label_preview" : "label";

    const getRenderField = () => {
        if (type === TEXT_TYPE && value) {
            return <span>{value}</span>;
        }

        if (type === AMOUNT_TYPE && amount) {
            return <FormattedAmount currency={amount.currency} quantity={amount.quantity} />;
        }

        return <div />;
    };

    return (
        <>
            <div className="data-wrapper">
                <FieldLabel
                    labelText={i18nUtils.getI18Component(labelText, lang, idActivity, idField)}
                    optional=""
                    idField={idField}
                />
                {getRenderField()}
            </div>
        </>
    );
};

ReadText.propTypes = {
    value: string,
    amount: shape({}),
    idField: string,
    mode: string,
    lang: string,
    idActivity: string,
    type: string,
};
ReadText.defaultProps = {
    value: "",
    amount: {},
    idField: "",
    mode: "",
    lang: "",
    idActivity: "",
    type: TEXT_TYPE,
};

export default ReadText;
